import ServiceOverviewSection from "../../services/ServiceOverviewSection";
import Service from "../../../models/Service";
import React, {useMemo} from "react";
import Team from "../../../models/Team";
import UserImageCircle from "../../../components/UserImageCircle";
import User from "../../../models/User";

const ServiceSearchCard = ({service, index, onSelect}) => {

    const serviceDisciplines = useMemo(() => TB.uniqBy(service.disciplines || [], 'id'), [])

    const featuredTeam = useMemo(() => {
        if (!service.featured_team) {
            return null;
        }
        let team = {...service.featured_team};

        let roles = TB.orderBy(team.positions, 'role', 'asc');
        team.matching_positions = TB.reduce(serviceDisciplines, (result, dis) => {
            let matchedUser = TB.find(roles, role => !TB.find(result || [], ['id', role.id]) && TB.find(role.disciplines || [], ['discipline_id', dis.id]));
            if (matchedUser && result?.length <= 2) {
                result.push(User.make({...matchedUser, discipline: dis}))
            }
            return result;
        }, []);

        // if (team.matching_positions?.length <= 2) {
        //     roles = TB.filter(roles, role => !TB.find(team.matching_positions, ['id', role.id]));
        //     if (roles.length) {
        //         team.matching_positions = TB.reduce(roles, (result, role) => {
        //
        //             let discipline = TB.sample(role.disciplines || []);
        //             if (discipline && result?.length <= 2) {
        //                 result.push(User.make({...role, discipline: UserDiscipline.storedDiscipline(discipline.discipline_id, true)}))
        //             }
        //             return result;
        //         }, team.matching_positions)
        //     }
        // }
        return Team.make(team);
    }, [service.featured_team]);

    return (
        <div className="bg-[#F7F8FA]">

            {/* USING INDEX === 0 AS AN EXAMPLE OF IT ON THE UI */}
            {/* {!!service.isTopMatch && ( */}
            {index === 0 && (
                <div className="py-1 px-7 inline-block bg-wripplePrimaryYellow mb-3 md:mb-0">
                    <p className="text-bold font-secondary uppercase">Top Match</p>
                </div>
            )}

            <div className="flex flex-col lg:flex-row gap-4 md:p-7 md:pl-0">
                <div className="w-full lg:w-2/3">

                    <div className="md:px-7 py-4 px-3 bg-primary">
                        <p className="text-2xl font-semibold text-white pb-3">{service.name}</p>
                        <p className="text-white">{service.description}</p>
                    </div>

                    <div className="pt-4 px-2 md:px-7">
                        <ServiceOverviewSection service={service}/>

                        <div className="flex flex-row items-center gap-3 pt-6">
                            {service.category.name && (
                                <div className="w-12 h-12 flex flex-col items-center justify-center"
                                     style={Service.categoryIcon(service.category.name)}>
                                    <i className={Service.categoryIconClass(service.category.name)}/>
                                </div>
                            )}
                            <div>
                                <p className="text-xxs">Category:</p>
                                <p className="uppercase font-semibold text-lg tracking-wide">{service.category.name}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="w-full lg:w-1/3 flex flex-col gap-6 p-2 md:p-0">

                    <div className="bg-white">
                        <div className="bg-[#61E29B] p-2">
                            {(service.approved_teams_count > 0 && featuredTeam) ? (
                                <p className="text-bold text-center">
                                    {TB.pluralize("ready-made team",service.approved_teams_count, true)} available!
                                </p>
                            ) : (
                                <p className="text-bold text-center">
                                    We'll curate a custom team for this project
                                </p>
                            )}
                        </div>

                        {(service.approved_teams_count > 0 && featuredTeam) ? (
                            <div className="flex flex-col items-stretch px-5 py-3">

                                <p className="text-semibold text-xxs mb-0.5 text-center">Example Team</p>
                                <h3 className="text-semibold text-lg text-center">{featuredTeam.name}</h3>

                                <p className="text-xs mt-0.5 text-center">
                                    <i className="fas fa-map-marker-alt text-wripplePrimaryYellow"></i>
                                    &nbsp;
                                    {featuredTeam.location?.full || TB.auth()?.user().clientOrg()?.location?.full || 'Atlanta, GA'}
                                </p>

                                <div className="mt-2">
                                    <div className="flex justify-between items-stretch pt-4">
                                        {featuredTeam.matching_positions?.length > 0 && featuredTeam.matching_positions.map(user => {
                                            const name = user.discipline?.name && TB.replace(user.discipline?.name, '+', ' + ')

                                            return (
                                                <div key={user.id} className="flex flex-col items-center flex-1 px-1">
                                                    <UserImageCircle
                                                        className="img-grayscale img-fluid rounded-full"
                                                        user={user} hideTooltip={true}
                                                        size={64}/>

                                                    <p className="text-center text-xs font-bold pt-3">{user.firstNamePlusInitial()}</p>
                                                    {name && (
                                                        <p className="text-xxs text-center">{name}</p>
                                                    )}
                                                </div>
                                            )
                                        })}
                                    </div>
                                    {featuredTeam.positions?.length - featuredTeam.matching_positions?.length > 0 && (
                                        <p className="text-xs text-center pt-3">
                                            + {TB.pluralize("Other", featuredTeam.positions?.length - featuredTeam.matching_positions?.length, true)}
                                        </p>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className="flex flex-col items-stretch p-5 gap-3">

                                {/*<p className="self-center mb-2 text-center flex flex-row gap-2 items-center">*/}
                                {/*    <i className="fas fa-check-circle text-success text-[15px]"/>*/}
                                {/*    <span className="font-medium">*/}
                                {/*        Curated Teams Available!*/}
                                {/*    </span>*/}
                                {/*</p>*/}
                                <p className="self-center mb-2 text-center font-semibold">
                                    Typical Team Roles
                                </p>

                                <div className="flex flex-row items-stretch justify-between divide-x">
                                    {serviceDisciplines?.length > 0 && TB.take(serviceDisciplines, 3).map(dis => {
                                        const name = TB.replace(dis.name, '+', ' + ')

                                        return (
                                            <div key={`ser-${service.id}-${dis.id}`} className="flex flex-col items-center gap-3 py-3 flex-1 px-2">

                                                <i className="fas fa-user circle text-[36px] text-success"/>

                                                <p className="text-xs font-bold text-center">
                                                    {name}
                                                </p>

                                            </div>
                                        )
                                    })}
                                    {serviceDisciplines?.length - 3 > 0 && (
                                        <div className="flex flex-col justify-center items-center flex-1 max-w-[56px] px-2">
                                            <p className="text-xxs text-center">
                                                + {TB.pluralize("Other", serviceDisciplines?.length - 3, true)}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="bg-white p-4">
                        <div className="">
                            <div className="pb-2 flex justify-between items-center">
                                <p className="text-gray2">Estimated Duration</p>
                                <p className="text-lg text-bold px-2">{service.duration}</p>
                            </div>

                            <div className="pb-2 flex justify-between items-center">
                                <p className="text-gray2">Estimated Cost</p>
                                <p className="text-lg text-bold">{TB.formatCurrency(service.ballpark_min)} - {TB.formatCurrency(service.ballpark_max)}</p>
                            </div>
                        </div>

                        <div className="pt-4">
                            <button type="button" onClick={() => onSelect()}
                                    className="btn btn-primary text-xs w-2/3 m-auto">
                                Select & Customize
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}


export default ServiceSearchCard;